
import { computed, defineComponent, ref, watch } from 'vue';
import { ComponentName } from '@/products/api/configuration/components/ComponentName';
import { setupComponent } from '@/products/composables/setupComponent';
import { DataType } from '@/products/api/configuration/application/DataType';
import { ImageItem, ProductDetailSearchResult } from '@/common/services/swagger/index.defs';

import InjectStyles from '@/common/components/InjectStyles.vue';
import ImageGallery from '@/common/components/ImageGallery.vue';
import { IDetailsGalleryOptions } from '@/products/api/configuration/components/IDetailsGalleryOptions';
import VRuntimeTemplate from 'vue3-runtime-template';
export default defineComponent({
  name: ComponentName.detailsGallery,

  components: {
    InjectStyles,
    ImageGallery,
    VRuntimeTemplate,
  },

  props: {
    instanceId: String,
    showPreview: { type: Boolean, default: true },
  },

  setup(props) {
    const root = ref<HTMLElement>();
    const images = ref<ImageItem[]>([]);
    const isLoading = ref(false);

    const { instance, componentName, isReady, isWebComponent, store, t, useProductsImages, emit } =
      setupComponent(root, props.instanceId, [DataType.Breadcrumbs, DataType.ProductDetails]);

    const { getProductsImages } = useProductsImages();

    const componentOptions = computed(
      () => store.value?.options.components?.detailsGallery ?? ({} as IDetailsGalleryOptions),
    );

    const productDetail = computed<ProductDetailSearchResult | undefined>(
      () => store.value?.data.productDetail || undefined,
    );

    const visible = computed(
      () =>
        componentOptions.value.visible &&
        productDetail.value?.item &&
        productDetail.value?.item.hideImages !== true,
    );

    watch(
      () => instance.value?.router.routeData,
      async (item) => {
        if (!item) {
          return;
        }

        const found = store.value?.data.itemNotFound != true;

        if (visible.value && found && item.productId && item.view === 'detail') {
          isLoading.value = true;
          images.value = [];
          images.value = (await getProductsImages([item.productId]))[item.productId];
          isLoading.value = false;
        }
      },
      { immediate: true, deep: true },
    );

    return {
      root,
      componentName,
      componentOptions,
      isReady,
      isWebComponent,
      isLoading,
      store,
      images,
      visible,
      instance,
      productDetail,
      t,
      emit,
    };
  },
});
